"use client";

import { useLayoutEffect, useState } from "react";

import type { BuilderContent } from "@builder.io/sdk-react";
import { useSearchParams } from "next/navigation";

import { useConfig } from "@jti/app-context/useConfig";

import { Content } from "@/libs/builder/Content";
import { sha256Hash } from "@/utils/sha256Hash";

const IS_SESSION_BYPASSED = "isSessionBypassed";

const getParamFromQueryStringOrHash = (searchParams: URLSearchParams, param: string): string | null =>
  searchParams.get(param) ?? new URLSearchParams(window.location.hash.split("?")[1] ?? "").get(param);

export const SoftAgeVerificationContent = ({ content }: { content: BuilderContent | null }) => {
  const config = useConfig();
  const searchParams = useSearchParams();
  const [isBypassed, setIsBypassed] = useState(true);

  useLayoutEffect(() => {
    const hashToken = async () => {
      const alreadyBypassed = sessionStorage.getItem(IS_SESSION_BYPASSED) === "true";
      if (alreadyBypassed) {
        setIsBypassed(true);
        return;
      }

      const savBypassToken = getParamFromQueryStringOrHash(searchParams, "savBypassToken");
      if (!savBypassToken) {
        setIsBypassed(false);
        return;
      }

      const hashedToken = await sha256Hash(savBypassToken);
      const valid = hashedToken === config.SAV_BYPASS_TOKEN;

      if (valid) {
        sessionStorage.setItem(IS_SESSION_BYPASSED, "true");
      }

      setIsBypassed(valid);
    };

    hashToken();
  }, [searchParams, config.SAV_BYPASS_TOKEN]);

  return isBypassed ? null : <Content model="soft-age-verification" content={content} />;
};
